import React from "react";
import { Upload, Button, message } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import { PlusSignIcon } from "@hugeicons/core-free-icons";
import { FormGroup, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";

const UploadProfileImage = ({ control }) => {
  const { t } = useTranslation();

  // Validate before upload
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }

    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Image must be smaller than 5MB!");
      return Upload.LIST_IGNORE;
    }

    return false; // Prevent auto upload, we'll handle it manually
  };

  return (
    <FormGroup className="fw-bold">
      <Label for="profile-image">{t("UPLOAD_PROFILE_IMAGE")}</Label>
      <Controller
        name="profile_image"
        control={control}
        render={({ field: { onChange, value } }) => {
          // Convert file to fileList format for Upload component
          const fileList = value ? [value] : [];

          const handleChange = ({ fileList: newFileList }) => {
            // Only keep the latest file and update the form
            const latestFile = newFileList.slice(-1)[0];
            onChange(latestFile || null);
          };

          return (
            <Upload
              beforeUpload={beforeUpload}
              onChange={handleChange}
              listType="picture-card"
              fileList={fileList}
              maxCount={1}
              accept="image/*"
              id="profile-image"
            >
              {fileList.length < 1 && (
                <Button
                  style={{
                    height: "100px",
                    width: "100px",
                    fontSize: "12px",
                    textAlign: "center",
                    display: "inline-flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "12px",
                    borderStyle: "dashed",
                    border: "unset",
                  }}
                >
                  <HugeiconsIcon icon={PlusSignIcon} />
                </Button>
              )}
            </Upload>
          );
        }}
      />
    </FormGroup>
  );
};

export default UploadProfileImage;
